import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { FlexLayoutModule } from '@angular/flex-layout';

import { FuseDirectivesModule } from '@fuse/directives/directives';
import { FusePipesModule } from '@fuse/pipes/pipes.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from './components';
import { FuseSuccessDialogModule } from './components/success-dialog/success-dialog.module';
import { FusePreviewDialogModule } from './components/preview-dialog/preview-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    FuseDirectivesModule,
    FusePipesModule,
    FuseProgressBarModule,
    FuseSidebarModule,
    FuseSuccessDialogModule,
    FusePreviewDialogModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    FuseDirectivesModule,
    FusePipesModule,
    FuseProgressBarModule,
    FuseSidebarModule,
    FuseSuccessDialogModule,
    FusePreviewDialogModule,
  ],
})
export class FuseSharedModule {}
